import simpleParallax from "simple-parallax-js/vanilla";

export default function () {
    document.addEventListener("DOMContentLoaded", () => {

        if (window.innerWidth <= 1024) return;

        const heroImages = document.querySelectorAll(".hero-header .background-image");

        if (heroImages.length > 0) {
            new simpleParallax(heroImages, {
                scale: 1.2,
                delay: 1,
                orientation: "up",
                transition: "cubic-bezier(0,0,0,1)",
                overflow: true,
            });
        }
    });
}
